import './style/index.less';
import MobileAccountLayout from './MobileAccountLayout';

export default MobileAccountLayout;
